import { render, staticRenderFns } from "./DeliveryCampaignGroupDetailsPage.vue?vue&type=template&id=72e4a0b2&scoped=true"
import script from "./DeliveryCampaignGroupDetailsPage.vue?vue&type=script&lang=js"
export * from "./DeliveryCampaignGroupDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCampaignGroupDetailsPage.vue?vue&type=style&index=0&id=72e4a0b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e4a0b2",
  null
  
)

export default component.exports